import { Component } from 'react'

import React = require('react');
import moment from 'moment';
import Spinner from '../components/share/Spinners/Spinners'
import { PER_PAGE_LIMIT_GALLERY } from '../const/page-list';
import GalleryService from '../services/gallery';
import { DANH_MUC } from '../const/danh-muc';
import { GALLERY_VARIABLE } from '../const/gallery';
import { GALLERY } from '../const/seo-url';
import { formatUrlSeo } from '../util/seo-url';
import { loadImage } from '../util/image';
import { GALLERY_HINH } from '../components/gallery/util';
import HinhDetail from '../components/gallery/HinhDetail';
import Image from "../components/share/Image"
import { CONTENT } from '../const/content';
import { HeaderService } from '../services';
import ContentComponent from '../components/share/ContentComponent';
import Layout from '../components/share/Layout';
import { PageTransition } from "next-page-transitions";
import SpinnersImageText from '../components/share/Spinners/SpinnersImageText';
import Paginate from '../components/share/Paging'


interface State { }
export default class extends Component<any, any> {
  page: number = 1
  per_page = 16
  count: 0;

  rows = {
    dau: ``
  }

  constructor(props) {
    super(props);
    this.count = 0;
    this.state = {
      danhSachGallery: [],
      page: 1,
      loading: false,
      album: [],
      open_hinh: false,
      url: ''
    }
  }

  static async getInitialProps({ req, query, asPath }) {
    const layoutProps = await Layout.getInitialProps();

    const danhMuc = asPath.substring(asPath.indexOf("=") + 1)
    const header = await HeaderService.getsHeader([CONTENT.CONTENT_ROYAL_HINHANH_BANNER_VN],
      []
    )
    const CONTENT_ROYAL_HINHANH_BANNER_VN = header.contentValue.find(x => x.key == CONTENT.CONTENT_ROYAL_HINHANH_BANNER_VN);
    return {
      layoutProps,
      danhMuc: danhMuc,
      CONTENT_ROYAL_HINHANH_BANNER_VN: CONTENT_ROYAL_HINHANH_BANNER_VN.content,
    }
  }

  componentDidMount() {
    this.getGalleries(this.page)
  }

  prevPage = () => {
    window.scrollTo(0, 0);
    this.getGalleries(--this.page)
  }

  nextPage = () => {
    window.scrollTo(0, 0);
    this.getGalleries(++this.page)
  }
  getGalleries = page => {
    GalleryService.search(
      PER_PAGE_LIMIT_GALLERY,
      page,
      {
        danh_muc_id: this.props.danhMuc,
        loai: 'h'
      }
    ).then(value => {
      this.count = value.count;

      /**
       * xét hình đại diện
       */
      if (value && value.galleries && value.galleries.length > 0) {
        value.galleries.forEach(x => {
          x['hinh_goc'] = x.loai == GALLERY_VARIABLE.VIDEO ? x.hinh_dai_dien : x.hinh_dai_dien.path;
          if (x.loai == GALLERY_VARIABLE.VIDEO) {
            x['url_chi_tiet'] = "/" + GALLERY.CHI_TIET_GALLERY_VIDEO + "/" + formatUrlSeo(x.url, x.gallery_id);
          }
          if (x.loai == GALLERY_VARIABLE.HINH) {
            try {
              let album: any[] = JSON.parse(x.data.files);
              let files = album.map(x => {
                return Object.assign({}, x, {
                  path: loadImage(x.path)
                })
              });

              x['album'] = GALLERY_HINH.getSizeImage(files, x.tieu_de);

              // x['album'] = files;

            } catch (ex) {
              x['album'] = [];
            }
          }
        })
      }
      this.setState({
        danhSachGallery: value.galleries || [],
        loading: true,
      })
    })
  }

  onPageChange = page => {
    window.scrollTo(0, 0);
    this.getGalleries(page.selected + 1);
  }

  /**
   * @author Bình
   * nếu loại = video
   *     -> vô page chi tiết video
   *    
   *     loại = hình
   *      -> mở modal hình lên xem
   */
  openDetail = (gallery) => {
    if (gallery.loai == GALLERY_VARIABLE.VIDEO) {
      window.location.href = gallery.url_chi_tiet
    }
    if (gallery.loai == GALLERY_VARIABLE.HINH) {
      if (gallery.album.length === 0) {
        alert('Không có albuml của hình này');
        return;
      }
      this.setState({
        album: gallery.album,
        open_hinh: true
      })
    }
  }

  render() {
    return (<div>
      <Layout title={this.props.title} {...this.props.layoutProps}>
        {/* <PageTransition timeout={400} classNames="page-transition"> */}
        <div >
          <ContentComponent content={this.props.CONTENT_ROYAL_HINHANH_BANNER_VN} />
          <div className="block">
            <div className="container">
              <div className="row">
                <div className="col text-center block-title">
                  <span>PHOTOS</span>
                </div>
              </div>
              <div className="row">
                {this.state.loading ? (
                  this.state.danhSachGallery.length > 0 ? (
                    this.state.danhSachGallery.map((x, index) => {
                      return <div
                        onClick={(e) => {
                          e.preventDefault();
                          this.openDetail(x)
                        }}
                        key={x.gallery_id}
                        className="col-xs-6 col-md-3 col-sm-3 no-padding-right  thumb-video"
                      >

                        <div className="img">
                          <Image
                            className="img-fluid thumb"
                            usefileurl={'true'}
                            alt={x.tieu_de}
                            src={x.hinh_dai_dien!.path}
                            classPlaceHolder="lazy-image-gallery"
                          />
                        </div>
                        <div className="textvideo trimtext">
                          <span className="text-bold">{x.tieu_de}</span>
                        </div>
                      </div>
                    }


                    )
                  ) : <div className="col-md-12">No data</div>) :
                  <div className="col-md-12 col-lg-12 col-xl-12">
                    <SpinnersImageText type={'placeholde'} loading={true} />
                  </div>}

              </div>

              {/* {+this.count > +PER_PAGE_LIMIT_GALLERY ? (
                <div className="row eve-paging">
                  <div className="sortPagiBar col-lg-9">
                    <div className="bottom-pagination">
                      <nav>
                        <div
                          className="btn-group mr-2 float-right"
                          role="group"
                          aria-label="First group"
                        >
                          {this.page == 1 ? (
                            <button
                              type="button"
                              className="btn btn-paging disabled"
                            >
                              {'Previous page'}
                            </button>
                          ) : (
                              <button
                                type="button"
                                className="btn btn-paging"
                                onClick={() => this.prevPage()}
                              >
                                {'Previous page'}
                              </button>
                            )}
                                                &nbsp;
                        {+this.count < +PER_PAGE_LIMIT_GALLERY
                            || (Math.ceil(this.count / PER_PAGE_LIMIT_GALLERY) == this.page) ? (
                              <button
                                type="button"
                                className="btn btn-paging disabled"
                              >
                                {'Next page'}
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-paging"
                                onClick={() => this.nextPage()}
                              >
                                {'Next page'}
                              </button>
                            )}
                        </div>
                      </nav>
                    </div>
                  </div>

                </div>
              ) : (
                  <div></div>
                )} */}
              {+this.count > +PER_PAGE_LIMIT_GALLERY ? (
                <div className="text-center">
                  <Paginate
                    onPageChange={this.onPageChange}
                    total={this.count}
                    perPage={PER_PAGE_LIMIT_GALLERY}
                    initialPage={this.state.page}
                  />
                </div>
              ) : null}
            </div>
            {this.state.open_hinh ? <HinhDetail close={() => {
              this.setState({
                album: [],
                open_hinh: false
              })
            }} images={this.state.album} tieu_de={this.state.tieu_de} /> : null}
          </div>
        </div>
        {/* </PageTransition> */}
        <style jsx global>
          {`
                .page-transition-enter {
                  opacity: 0;
                }
                .page-transition-enter-active {
                  opacity: 1;
                  transition: opacity ${400}ms;
                }
                .page-transition-exit {
                  opacity: 1;
                }
                .page-transition-exit-active {
                  opacity: 0;
                  transition: opacity ${400}ms;
                }
              `}
        </style>

      </Layout>
    </div>


      // </Layout>
    )
  }
}